import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import ChipsSelect from '~/components/ChipsSelect';
import { LocationSelect } from '~/components/LocationSelect';
import { useTrackEvent } from '~/globals/trackEvent';
import { useDirectories } from '~/hooks/useDirectories';
import { maxWidth, minWidth } from '~/styles/media';

const Container = styled.div`
  display: flex;
  min-width: 0;

  @media ${maxWidth('md')} {
    flex-direction: column;
  }

  @media ${minWidth('md')} {
    margin-top: 17px;
  }
`;

const LocationContainer = styled.div`
  @media ${maxWidth('md')} {
    margin-top: 13px;
  }

  @media ${minWidth('md')} {
    margin-right: 26px;
  }
`;

const StyledChipsSelect = styled(ChipsSelect)`
  min-width: 0;

  @media ${maxWidth('sm')} {
    margin-top: 16px;
  }

  @media ${minWidth('sm')} and ${maxWidth('md')} {
    margin-top: 24px;
  }
`;

const ChipsSelectPlaceholder = styled.div`
  height: 36px;

  @media ${maxWidth('sm')} {
    margin-top: 16px;
  }

  @media ${minWidth('sm')} and ${maxWidth('md')} {
    margin-top: 24px;
  }

  @media ${minWidth('md')} {
    display: none;
  }
`;

type Props = {
  /**
   * role_types array, for ex.
   */
  defaultTypeValue?: string[];
  hideLocationSelect?: boolean;
};

const SearchRefinementForm = ({ defaultTypeValue, hideLocationSelect }: Props) => {
  const { roleDirectories } = useDirectories();
  const router = useRouter();
  const [type, setType] = useState<any>(); // TSFIXME Directory
  const [location, setLocation] = useState<string | undefined>();
  const locationSelectValue = location ?? (typeof router.query.loc === 'string' ? router.query.loc : undefined);

  useEffect(() => {
    if (defaultTypeValue?.length) {
      // select first dirctory with any overlap in role types
      // for ex.: ["venue", "guest-accomodations"] matches ["venue"]
      const initType = roleDirectories.find((dir) => {
        return dir.role_types.some((role) => defaultTypeValue.includes(role));
      });

      initType && setType(initType);
    } else {
      setType({ id: null, name: 'All Vendors', bg_color: '#999999' });
    }
  }, [defaultTypeValue, roleDirectories]);

  const trackEvent = useTrackEvent();

  const onClickSearch = (type) => {
    trackEvent('search', {
      query: type.slug,
      content_type: 'business',
      ...(locationSelectValue ? { locationSelectValue } : {}),
    });

    // router.push(
    //   locationSelectValue === undefined
    //     ? '/' + (type.slug ?? 'wedding-vendors')
    //     : `/results?q=${type.slug ?? ''}&loc=${locationSelectValue}`
    // );
    router.push(
      locationSelectValue === undefined
        ? '/' + (type.slug ?? 'wedding-vendors')
        : `/${type.slug ?? 'wedding-vendors'}/${locationSelectValue}`
    );
  };

  const options =
    roleDirectories.length > 0 ? [{ id: null, name: 'All', bg_color: '#999999' }, ...roleDirectories] : undefined;

  return (
    <Container>
      {!hideLocationSelect && (
        <LocationContainer>
          <LocationSelect
            placeholder="Where are you getting married?"
            value={locationSelectValue}
            onChange={setLocation}
            onClickSearch={() => onClickSearch(type)}
          />
        </LocationContainer>
      )}
      {options && type !== undefined ? (
        <StyledChipsSelect
          options={options.map((o) => ({ id: o.id, label: o.name }))}
          value={type}
          onChange={(type) => {
            setType(type);
            onClickSearch(type);
          }}
        />
      ) : (
        <ChipsSelectPlaceholder />
      )}
    </Container>
  );
};

export default SearchRefinementForm;
